import {ApiClient, createApiClient} from '@/api/client/apiClient.ts';
import {App, InjectionKey, Plugin} from 'vue'
import {
  BaseBearerTokenAuthenticationProvider,
  ParseNodeFactoryRegistry,
} from "@microsoft/kiota-abstractions";
import {FetchRequestAdapter} from "@microsoft/kiota-http-fetchlibrary";
import {MsalAccessTokenProvider} from "@/app/auth/msal-token-provider.ts";
import {EmptyJsonParseNodeFactory} from "@/api/empty-json-parse-node-factory.ts";

export const apiClientKey: InjectionKey<ApiClient> = Symbol('AllotmentApiClient')

const AllotmentApiClientPlugin: Plugin = {
  install(app: App) {

    const allowedHosts = new Set<string>();
    const tokenProvider = new MsalAccessTokenProvider(allowedHosts)
    const authProvider = new BaseBearerTokenAuthenticationProvider(tokenProvider)

    const requestAdapter = new FetchRequestAdapter(authProvider);
    requestAdapter.baseUrl = `/${import.meta.env.VITE_API_ROOT}`;

    const apiClient = createApiClient(requestAdapter);
    const parseNodeFactoryRegistry = requestAdapter.getParseNodeFactory() as ParseNodeFactoryRegistry;
    parseNodeFactoryRegistry.registerDefaultDeserializer(
      EmptyJsonParseNodeFactory,
      requestAdapter.getBackingStoreFactory()
    );

    app.provide(apiClientKey, apiClient);
  }
}

export default AllotmentApiClientPlugin;
